@if (loading$ | async) {
  <div class="loader-container">
    <div class="spinner" role="progressbar">
      <svg
        class="circular"
        preserveAspectRatio="xMidYMid meet"
        focusable="false"
        viewBox="0 0 100 100"
      >
        <circle cx="50%" cy="50%" r="45" class="path"></circle>
      </svg>
    </div>
    <div class="progressring-group">
      <div class="progressring" role="progressbar">
        <div class="circle"></div>
        <div class="circle"></div>
        <div class="circle"></div>
        <div class="circle"></div>
        <div class="circle"></div>
      </div>
    </div>
    <div class="label">Generating report...</div>
  </div>
}
@if ((loading$ | async) === false) {
  <div class="print-btn-wrap">
    <button class="print-btn" mat-button (click)="print()">
      <mat-icon
        class="material-icons-outlined"
        tabindex="0"
        aria-label="info icon"
        >print</mat-icon
      >Print
    </button>
    <div class="print-options-box">
      <mat-checkbox
        class="print-options-checkbox"
        labelPosition="before"
        [(ngModel)]="includeComments"
        >Include comments appendix</mat-checkbox
      >
    </div>
  </div>
  <div class="animate__animated animate__fadeIn print-layout-container">
    <div class="print-layout-inner-container">
      <div class="print-layout">
        <img
          src="../../../../assets/oash-logo-bw.svg"
          class="print-logo"
          alt="OASH Office of Population Affairs logo"
        />
        <div class="print-title">
          <p class="print-title-intro">
            {{ dataReportingPeriodYear }} FPAR<br />
            Reporting Period<br />
            Summary for
          </p>
          <p class="print-title-grant">{{ fparReportData.granteeName }}</p>
        </div>
        <div class="print-project-director">
          <p class="print-project-director-label">Title X Project Director</p>
          <p class="print-project-director-name">
            {{ grantCoverSheetDirector.grProjDirFirst }}
            {{ grantCoverSheetDirector.grProjDirLast }}
          </p>
        </div>
        <div class="print-contact-person">
          <p class="print-contact-person-label">Grantee Contact Person</p>
          <p class="print-contact-person-name">
            {{ grantCoverSheetContact.grContactFirst }}
            {{ grantCoverSheetContact.grContactLast }}
          </p>
        </div>
        <table class="print-cover-sheet-info">
          <tbody>
            <tr>
              <td>FPAR number</td>
              <td>{{ fparReportData.grFparNumber }}</td>
            </tr>
            <tr>
              <td>Accepted date</td>
              <td>{{ acceptedDate }}</td>
            </tr>
            <tr>
              <td>Grant reporting period</td>
              <td>{{ fparReportData.reportingPeriodName }}</td>
            </tr>
            <tr>
              <td>Number of sites supported</td>
              <td>{{ grantNumberofSites.titlexSites }}</td>
            </tr>
          </tbody>
        </table>
        <div class="print-last-updated">
          <p class="print-project-director-label">Report generated:</p>
          <p class="print-project-director-date">{{ today }}</p>
        </div>
      </div>
      <div class="page-break"></div>
      <div class="print-layout">
        <p class="print-toc-header">Table of Contents</p>
        <table class="print-toc">
          <tbody>
            <tr>
              <td>1</td>
              <td>
                Unduplicated Number of Family Planning Users by Age Group and
                Sex
              </td>
            </tr>
            <tr>
              <td>2</td>
              <td>
                Unduplicated Number of Female Family Planning Users by Race and
                Ethnicity
              </td>
            </tr>
            <tr>
              <td>3</td>
              <td>
                Unduplicated Number of Male Family Planning Users by Race and
                Ethnicity
              </td>
            </tr>
            <tr>
              <td>4</td>
              <td>
                Unduplicated Number of Family Planning Users by Income Level
              </td>
            </tr>
            <tr>
              <td>5</td>
              <td>
                Unduplicated Number of Family Planning Users by Principal Health
                Insurance Coverage Status
              </td>
            </tr>
            <tr>
              <td>6</td>
              <td>
                Unduplicated Number of Family Planning Users with Limited
                English Proficiency (LEP)
              </td>
            </tr>
            <tr>
              <td>7</td>
              <td>
                Unduplicated Number of Female Family Planning Users by Primary
                Method and Age Group
              </td>
            </tr>
            <tr>
              <td>8</td>
              <td>
                Unduplicated Number of Male Family Planning Users by Primary
                Method and Age Group
              </td>
            </tr>
            <tr>
              <td>9</td>
              <td>Cervical Cancer Screening Activities</td>
            </tr>
            <tr>
              <td>10</td>
              <td>Clinical Breast Exams and Referrals</td>
            </tr>
            <tr>
              <td>11</td>
              <td>
                Unduplicated Number of Family Planning Users Tested for
                Chlamydia by Age Group and Sex
              </td>
            </tr>
            <tr>
              <td>12</td>
              <td>
                Number of Tests for Gonorrhea, Syphilis, and HIV and Number of
                Positive Confidential HIV Tests
              </td>
            </tr>
            <tr>
              <td>13</td>
              <td>
                Number of Full-Time Equivalent Clinical Services Providers and
                Family Planning Encounters by Type of Provider
              </td>
            </tr>
            <tr>
              <td>14</td>
              <td>Revenue Report</td>
            </tr>
            <tr>
              <td>15</td>
              <td>Appendix</td>
            </tr>
          </tbody>
        </table>
        <app-print-submission-footer
          class="print-footer"
          [year]="dataReportingPeriodYear"
          [granteeName]="fparReportData.granteeName"
        ></app-print-submission-footer>
      </div>
      <div class="page-break"></div>
      <div class="print-layout">
        <ol class="print-numbered-heading-1">
          <li class="print-numbered-heading-1-item">
            {{ fparReportData.fparTables[0].tableName }}
          </li>
          <li class="print-numbered-heading-1-item-title">
            {{ fparReportData.fparTables[0].tableTitle }}
          </li>
        </ol>
        <table class="print-table">
          <thead>
            <tr>
              <th></th>
              <th></th>
              <th scope="col">Female Users</th>
              <th scope="col">Male Users</th>
              <th scope="col">Total</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <th rowspan="10" scope="row" class="bold">Age Group</th>
            </tr>
            <tr>
              <td>
                {{ fparReportData.fparTables[0].rows.current[0].rowLabel }}
              </td>
              <td>{{ fparReportData.fparTables[0].rows.current[0].female }}</td>
              <td>{{ fparReportData.fparTables[0].rows.current[0].male }}</td>
              <td>{{ rowTotals[0][0] }}</td>
            </tr>
            <tr>
              <td>
                {{ fparReportData.fparTables[0].rows.current[1].rowLabel }}
              </td>
              <td>{{ fparReportData.fparTables[0].rows.current[1].female }}</td>
              <td>{{ fparReportData.fparTables[0].rows.current[1].male }}</td>
              <td>{{ rowTotals[0][1] }}</td>
            </tr>
            <tr>
              <td>
                {{ fparReportData.fparTables[0].rows.current[2].rowLabel }}
              </td>
              <td>{{ fparReportData.fparTables[0].rows.current[2].female }}</td>
              <td>{{ fparReportData.fparTables[0].rows.current[2].male }}</td>
              <td>{{ rowTotals[0][2] }}</td>
            </tr>
            <tr>
              <td>
                {{ fparReportData.fparTables[0].rows.current[3].rowLabel }}
              </td>
              <td>{{ fparReportData.fparTables[0].rows.current[3].female }}</td>
              <td>{{ fparReportData.fparTables[0].rows.current[3].male }}</td>
              <td>{{ rowTotals[0][3] }}</td>
            </tr>
            <tr>
              <td>
                {{ fparReportData.fparTables[0].rows.current[4].rowLabel }}
              </td>
              <td>{{ fparReportData.fparTables[0].rows.current[4].female }}</td>
              <td>{{ fparReportData.fparTables[0].rows.current[4].male }}</td>
              <td>{{ rowTotals[0][4] }}</td>
            </tr>
            <tr>
              <td>
                {{ fparReportData.fparTables[0].rows.current[5].rowLabel }}
              </td>
              <td>{{ fparReportData.fparTables[0].rows.current[5].female }}</td>
              <td>{{ fparReportData.fparTables[0].rows.current[5].male }}</td>
              <td>{{ rowTotals[0][5] }}</td>
            </tr>
            <tr>
              <td>
                {{ fparReportData.fparTables[0].rows.current[6].rowLabel }}
              </td>
              <td>{{ fparReportData.fparTables[0].rows.current[6].female }}</td>
              <td>{{ fparReportData.fparTables[0].rows.current[6].male }}</td>
              <td>{{ rowTotals[0][6] }}</td>
            </tr>
            <tr>
              <td>
                {{ fparReportData.fparTables[0].rows.current[7].rowLabel }}
              </td>
              <td>{{ fparReportData.fparTables[0].rows.current[7].female }}</td>
              <td>{{ fparReportData.fparTables[0].rows.current[7].male }}</td>
              <td>{{ rowTotals[0][7] }}</td>
            </tr>
            <tr>
              <td>
                {{ fparReportData.fparTables[0].rows.current[8].rowLabel }}
              </td>
              <td>{{ fparReportData.fparTables[0].rows.current[8].female }}</td>
              <td>{{ fparReportData.fparTables[0].rows.current[8].male }}</td>
              <td>{{ rowTotals[0][8] }}</td>
            </tr>
            <tr>
              <th>Total</th>
              <td></td>
              <td class="bold text-align-right">
                {{ columnTotals[0] }}
              </td>
              <td class="bold text-align-right">
                {{ columnTotals[1] }}
              </td>
              <td class="bold text-align-right">
                {{ totalTotals[0] }}
              </td>
            </tr>
          </tbody>
        </table>
        <app-print-submission-footer
          class="print-footer"
          [year]="dataReportingPeriodYear"
          [granteeName]="fparReportData.granteeName"
          pageNumber="1"
        ></app-print-submission-footer>
      </div>
      <div class="page-break"></div>
      <div class="print-layout">
        <ol class="print-numbered-heading-1">
          <li class="print-numbered-heading-1-item">
            {{ fparReportData.fparTables[1].tableName }}
          </li>
          <li class="print-numbered-heading-1-item-title">
            Unduplicated Number of Female Family Planning Users by Race and
            Ethnicity
          </li>
        </ol>
        <table class="print-table">
          <thead>
            <tr>
              <th></th>
              <th></th>
              <th scope="col">Hispanic<br />or Latino</th>
              <th scope="col">Not Hispanic<br />or Latino</th>
              <th scope="col">Unknown/Not<br />Reported</th>
              <th scope="col">Total</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <th rowspan="8" scope="row" class="bold">Race</th>
            </tr>
            <tr>
              <td>American Indian or Alaska Native</td>
              <td>
                {{ fparReportData.fparTables[1].rows.current[0].hispanic }}
              </td>
              <td>
                {{ fparReportData.fparTables[1].rows.current[0].notHispanic }}
              </td>
              <td>
                {{ fparReportData.fparTables[1].rows.current[0].unknown }}
              </td>
              <td>{{ rowTotals[1][0] }}</td>
            </tr>
            <tr>
              <td>Asian</td>
              <td>
                {{ fparReportData.fparTables[1].rows.current[1].hispanic }}
              </td>
              <td>
                {{ fparReportData.fparTables[1].rows.current[1].notHispanic }}
              </td>
              <td>
                {{ fparReportData.fparTables[1].rows.current[1].unknown }}
              </td>
              <td>{{ rowTotals[1][1] }}</td>
            </tr>
            <tr>
              <td>Black or African American</td>
              <td>
                {{ fparReportData.fparTables[1].rows.current[2].hispanic }}
              </td>
              <td>
                {{ fparReportData.fparTables[1].rows.current[2].notHispanic }}
              </td>
              <td>
                {{ fparReportData.fparTables[1].rows.current[2].unknown }}
              </td>
              <td>{{ rowTotals[1][2] }}</td>
            </tr>
            <tr>
              <td>Native Hawaiian or Other Pacific Islander</td>
              <td>
                {{ fparReportData.fparTables[1].rows.current[3].hispanic }}
              </td>
              <td>
                {{ fparReportData.fparTables[1].rows.current[3].notHispanic }}
              </td>
              <td>
                {{ fparReportData.fparTables[1].rows.current[3].unknown }}
              </td>
              <td>{{ rowTotals[1][3] }}</td>
            </tr>
            <tr>
              <td>White</td>
              <td>
                {{ fparReportData.fparTables[1].rows.current[4].hispanic }}
              </td>
              <td>
                {{ fparReportData.fparTables[1].rows.current[4].notHispanic }}
              </td>
              <td>
                {{ fparReportData.fparTables[1].rows.current[4].unknown }}
              </td>
              <td>{{ rowTotals[1][4] }}</td>
            </tr>
            <tr>
              <td>More than one race</td>
              <td>
                {{ fparReportData.fparTables[1].rows.current[5].hispanic }}
              </td>
              <td>
                {{ fparReportData.fparTables[1].rows.current[5].notHispanic }}
              </td>
              <td>
                {{ fparReportData.fparTables[1].rows.current[5].unknown }}
              </td>
              <td>{{ rowTotals[1][5] }}</td>
            </tr>
            <tr>
              <td>Unknown/not reported</td>
              <td>
                {{ fparReportData.fparTables[1].rows.current[6].hispanic }}
              </td>
              <td>
                {{ fparReportData.fparTables[1].rows.current[6].notHispanic }}
              </td>
              <td>
                {{ fparReportData.fparTables[1].rows.current[6].unknown }}
              </td>
              <td>{{ rowTotals[1][6] }}</td>
            </tr>
            <tr>
              <th>Total</th>
              <td></td>
              <td class="bold text-align-right">
                {{ columnTotals[2] }}
              </td>
              <td class="bold text-align-right">
                {{ columnTotals[3] }}
              </td>
              <td class="bold text-align-right">
                {{ columnTotals[4] }}
              </td>
              <td class="bold text-align-right">
                {{ totalTotals[1] }}
              </td>
            </tr>
          </tbody>
        </table>
        <app-print-submission-footer
          class="print-footer"
          [year]="dataReportingPeriodYear"
          [granteeName]="fparReportData.granteeName"
          pageNumber="2"
        ></app-print-submission-footer>
      </div>
      <div class="page-break"></div>
      <div class="print-layout">
        <ol class="print-numbered-heading-1">
          <li class="print-numbered-heading-1-item">
            {{ fparReportData.fparTables[2].tableName }}
          </li>
          <li class="print-numbered-heading-1-item-title">
            Unduplicated Number of Male Family Planning Users by Race and
            Ethnicity
          </li>
        </ol>
        <table class="print-table">
          <thead>
            <tr>
              <th></th>
              <th></th>
              <th scope="col">Hispanic<br />or Latino</th>
              <th scope="col">Not Hispanic<br />or Latino</th>
              <th scope="col">Unknown/Not<br />Reported</th>
              <th scope="col">Total</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <th rowspan="8" scope="row" class="bold">Race</th>
            </tr>
            <tr>
              <td>American Indian or Alaska Native</td>
              <td>
                {{ fparReportData.fparTables[2].rows.current[0].hispanic }}
              </td>
              <td>
                {{ fparReportData.fparTables[2].rows.current[0].notHispanic }}
              </td>
              <td>
                {{ fparReportData.fparTables[2].rows.current[0].unknown }}
              </td>
              <td>{{ rowTotals[2][0] }}</td>
            </tr>
            <tr>
              <td>Asian</td>
              <td>
                {{ fparReportData.fparTables[2].rows.current[1].hispanic }}
              </td>
              <td>
                {{ fparReportData.fparTables[2].rows.current[1].notHispanic }}
              </td>
              <td>
                {{ fparReportData.fparTables[2].rows.current[1].unknown }}
              </td>
              <td>{{ rowTotals[2][1] }}</td>
            </tr>
            <tr>
              <td>Black or African American</td>
              <td>
                {{ fparReportData.fparTables[2].rows.current[2].hispanic }}
              </td>
              <td>
                {{ fparReportData.fparTables[2].rows.current[2].notHispanic }}
              </td>
              <td>
                {{ fparReportData.fparTables[2].rows.current[2].unknown }}
              </td>
              <td>{{ rowTotals[2][2] }}</td>
            </tr>
            <tr>
              <td>Native Hawaiian or Other Pacific Islander</td>
              <td>
                {{ fparReportData.fparTables[2].rows.current[3].hispanic }}
              </td>
              <td>
                {{ fparReportData.fparTables[2].rows.current[3].notHispanic }}
              </td>
              <td>
                {{ fparReportData.fparTables[2].rows.current[3].unknown }}
              </td>
              <td>{{ rowTotals[2][3] }}</td>
            </tr>
            <tr>
              <td>White</td>
              <td>
                {{ fparReportData.fparTables[2].rows.current[4].hispanic }}
              </td>
              <td>
                {{ fparReportData.fparTables[2].rows.current[4].notHispanic }}
              </td>
              <td>
                {{ fparReportData.fparTables[2].rows.current[4].unknown }}
              </td>
              <td>{{ rowTotals[2][4] }}</td>
            </tr>
            <tr>
              <td>More than one race</td>
              <td>
                {{ fparReportData.fparTables[2].rows.current[5].hispanic }}
              </td>
              <td>
                {{ fparReportData.fparTables[2].rows.current[5].notHispanic }}
              </td>
              <td>
                {{ fparReportData.fparTables[2].rows.current[5].unknown }}
              </td>
              <td>{{ rowTotals[2][5] }}</td>
            </tr>
            <tr>
              <td>Unknown/not reported</td>
              <td>
                {{ fparReportData.fparTables[2].rows.current[6].hispanic }}
              </td>
              <td>
                {{ fparReportData.fparTables[2].rows.current[6].notHispanic }}
              </td>
              <td>
                {{ fparReportData.fparTables[2].rows.current[6].unknown }}
              </td>
              <td>{{ rowTotals[2][6] }}</td>
            </tr>
            <tr>
              <th>Total</th>
              <td></td>
              <td class="bold text-align-right">
                {{ columnTotals[5] }}
              </td>
              <td class="bold text-align-right">
                {{ columnTotals[6] }}
              </td>
              <td class="bold text-align-right">
                {{ columnTotals[7] }}
              </td>
              <td class="bold text-align-right">
                {{ totalTotals[2] }}
              </td>
            </tr>
          </tbody>
        </table>
        <app-print-submission-footer
          class="print-footer"
          [year]="dataReportingPeriodYear"
          [granteeName]="fparReportData.granteeName"
          pageNumber="3"
        ></app-print-submission-footer>
      </div>
      <div class="page-break"></div>
      <div class="print-layout">
        <ol class="print-numbered-heading-1">
          <li class="print-numbered-heading-1-item">
            {{ fparReportData.fparTables[3].tableName }}
          </li>
          <li class="print-numbered-heading-1-item-title">
            Unduplicated Number of Family Planning Users by Income Level
          </li>
        </ol>
        <table class="print-table">
          <thead>
            <tr>
              <th></th>
              <th></th>
              <th scope="col">Total</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <th rowspan="7" scope="row" class="bold">
                Income Level as a Percentage of the HHS Poverty Guidelines
              </th>
            </tr>
            <tr>
              <td>100% and below</td>
              <td>{{ fparReportData.fparTables[3].rows.current[0].value }}</td>
            </tr>
            <tr>
              <td>101% to 150%</td>
              <td>{{ fparReportData.fparTables[3].rows.current[1].value }}</td>
            </tr>
            <tr>
              <td>151% to 200%</td>
              <td>{{ fparReportData.fparTables[3].rows.current[2].value }}</td>
            </tr>
            <tr>
              <td>201% to 250%</td>
              <td>{{ fparReportData.fparTables[3].rows.current[3].value }}</td>
            </tr>
            <tr>
              <td>Over 250%</td>
              <td>{{ fparReportData.fparTables[3].rows.current[4].value }}</td>
            </tr>
            <tr>
              <td>Unknown/not reported</td>
              <td>{{ fparReportData.fparTables[3].rows.current[5].value }}</td>
            </tr>
            <tr>
              <th>Total</th>
              <td></td>
              <td class="bold text-align-right">
                {{ totalTotals[3] }}
              </td>
            </tr>
          </tbody>
        </table>
        <app-print-submission-footer
          class="print-footer"
          [year]="dataReportingPeriodYear"
          [granteeName]="fparReportData.granteeName"
          pageNumber="4"
        ></app-print-submission-footer>
      </div>
      <div class="page-break"></div>
      <div class="print-layout">
        <ol class="print-numbered-heading-1">
          <li class="print-numbered-heading-1-item">
            {{ fparReportData.fparTables[4].tableName }}
          </li>
          <li class="print-numbered-heading-1-item-title">
            Unduplicated Number of Family Planning Users by Principal Health
            Insurance Coverage Status
          </li>
        </ol>
        <table class="print-table">
          <thead>
            <tr>
              <th></th>
              <th></th>
              <th scope="col">Total</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <th rowspan="5" scope="row" class="bold">
                Principal Health Insurance Covering Primary Medical Care
              </th>
            </tr>
            <tr>
              <td>Public health insurance covering primary medical care</td>
              <td>{{ fparReportData.fparTables[4].rows.current[0].value }}</td>
            </tr>
            <tr>
              <td>Private health insurance covering primary medical care</td>
              <td>{{ fparReportData.fparTables[4].rows.current[1].value }}</td>
            </tr>
            <tr>
              <td>Uninsured (no public or private health insurance)</td>
              <td>{{ fparReportData.fparTables[4].rows.current[2].value }}</td>
            </tr>
            <tr>
              <td>Unknown/not reported</td>
              <td>{{ fparReportData.fparTables[4].rows.current[3].value }}</td>
            </tr>
            <tr>
              <th>Total</th>
              <td></td>
              <td class="bold text-align-right">
                {{ totalTotals[4] }}
              </td>
            </tr>
          </tbody>
        </table>
        <app-print-submission-footer
          class="print-footer"
          [year]="dataReportingPeriodYear"
          [granteeName]="fparReportData.granteeName"
          pageNumber="5"
        ></app-print-submission-footer>
      </div>
      <div class="page-break"></div>
      <div class="print-layout">
        <ol class="print-numbered-heading-1">
          <li class="print-numbered-heading-1-item">
            {{ fparReportData.fparTables[5].tableName }}
          </li>
          <li class="print-numbered-heading-1-item-title">
            Unduplicated Number of Family Planning Users with Limited English
            Proficiency (LEP)
          </li>
        </ol>
        <table class="print-table">
          <thead>
            <tr>
              <th></th>
              <th scope="col">Total</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>LEP users</td>
              <td>{{ fparReportData.fparTables[5].rows.current[0].value }}</td>
            </tr>
            <tr>
              <td>Not LEP users</td>
              <td>{{ fparReportData.fparTables[5].rows.current[1].value }}</td>
            </tr>
            <tr>
              <td>Unknown/not reported</td>
              <td>{{ fparReportData.fparTables[5].rows.current[2].value }}</td>
            </tr>
            <tr>
              <th>Total</th>
              <td class="bold text-align-right">
                {{ totalTotals[5] }}
              </td>
            </tr>
          </tbody>
        </table>
        <app-print-submission-footer
          class="print-footer"
          [year]="dataReportingPeriodYear"
          [granteeName]="fparReportData.granteeName"
          pageNumber="6"
        ></app-print-submission-footer>
      </div>
      <div class="page-break"></div>
      <div class="print-layout">
        <ol class="print-numbered-heading-1">
          <li class="print-numbered-heading-1-item">
            {{ fparReportData.fparTables[6].tableName }}
          </li>
          <li class="print-numbered-heading-1-item-title">
            Unduplicated Number of Female Family Planning Users by Primary
            Method and Age Group
          </li>
        </ol>
        <table class="print-table">
          <colgroup>
            <col class="col-width-68" />
            <col class="col-width-54" />
            <col />
            <col />
            <col />
            <col />
            <col />
            <col />
            <col />
            <col />
            <col />
            <col />
          </colgroup>
          <thead>
            <tr>
              <th></th>
              <th></th>
              <th scope="col">Under 15</th>
              <th scope="col">15 to 17</th>
              <th scope="col">18 to 19</th>
              <th scope="col">20 to 24</th>
              <th scope="col">25 to 29</th>
              <th scope="col">30 to 34</th>
              <th scope="col">35 to 39</th>
              <th scope="col">40 to 44</th>
              <th scope="col">Over 44</th>
              <th scope="col">Total</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <th rowspan="16" scope="row" class="bold">Primary Method</th>
            </tr>
            <tr>
              <td>Female sterilization</td>
              <td>
                {{ fparReportData.fparTables[6].rows.current[0].ageUnder_15 }}
              </td>
              <td>
                {{ fparReportData.fparTables[6].rows.current[0].age_15To_17 }}
              </td>
              <td>
                {{ fparReportData.fparTables[6].rows.current[0].age_18To_19 }}
              </td>
              <td>
                {{ fparReportData.fparTables[6].rows.current[0].age_20To_24 }}
              </td>
              <td>
                {{ fparReportData.fparTables[6].rows.current[0].age_25To_29 }}
              </td>
              <td>
                {{ fparReportData.fparTables[6].rows.current[0].age_30To_34 }}
              </td>
              <td>
                {{ fparReportData.fparTables[6].rows.current[0].age_35To_39 }}
              </td>
              <td>
                {{ fparReportData.fparTables[6].rows.current[0].age_40To_44 }}
              </td>
              <td>
                {{ fparReportData.fparTables[6].rows.current[0].ageOver_44 }}
              </td>
              <td>{{ rowTotals[6][0] }}</td>
            </tr>
            <tr>
              <td>IUD or IUS</td>
              <td>
                {{ fparReportData.fparTables[6].rows.current[1].ageUnder_15 }}
              </td>
              <td>
                {{ fparReportData.fparTables[6].rows.current[1].age_15To_17 }}
              </td>
              <td>
                {{ fparReportData.fparTables[6].rows.current[1].age_18To_19 }}
              </td>
              <td>
                {{ fparReportData.fparTables[6].rows.current[1].age_20To_24 }}
              </td>
              <td>
                {{ fparReportData.fparTables[6].rows.current[1].age_25To_29 }}
              </td>
              <td>
                {{ fparReportData.fparTables[6].rows.current[1].age_30To_34 }}
              </td>
              <td>
                {{ fparReportData.fparTables[6].rows.current[1].age_35To_39 }}
              </td>
              <td>
                {{ fparReportData.fparTables[6].rows.current[1].age_40To_44 }}
              </td>
              <td>
                {{ fparReportData.fparTables[6].rows.current[1].ageOver_44 }}
              </td>
              <td>{{ rowTotals[6][1] }}</td>
            </tr>
            <tr>
              <td>Hormonal implant</td>
              <td>
                {{ fparReportData.fparTables[6].rows.current[2].ageUnder_15 }}
              </td>
              <td>
                {{ fparReportData.fparTables[6].rows.current[2].age_15To_17 }}
              </td>
              <td>
                {{ fparReportData.fparTables[6].rows.current[2].age_18To_19 }}
              </td>
              <td>
                {{ fparReportData.fparTables[6].rows.current[2].age_20To_24 }}
              </td>
              <td>
                {{ fparReportData.fparTables[6].rows.current[2].age_25To_29 }}
              </td>
              <td>
                {{ fparReportData.fparTables[6].rows.current[2].age_30To_34 }}
              </td>
              <td>
                {{ fparReportData.fparTables[6].rows.current[2].age_35To_39 }}
              </td>
              <td>
                {{ fparReportData.fparTables[6].rows.current[2].age_40To_44 }}
              </td>
              <td>
                {{ fparReportData.fparTables[6].rows.current[2].ageOver_44 }}
              </td>
              <td>{{ rowTotals[6][2] }}</td>
            </tr>
            <tr>
              <td>1-Month hormonal injection</td>
              <td>
                {{ fparReportData.fparTables[6].rows.current[3].ageUnder_15 }}
              </td>
              <td>
                {{ fparReportData.fparTables[6].rows.current[3].age_15To_17 }}
              </td>
              <td>
                {{ fparReportData.fparTables[6].rows.current[3].age_18To_19 }}
              </td>
              <td>
                {{ fparReportData.fparTables[6].rows.current[3].age_20To_24 }}
              </td>
              <td>
                {{ fparReportData.fparTables[6].rows.current[3].age_25To_29 }}
              </td>
              <td>
                {{ fparReportData.fparTables[6].rows.current[3].age_30To_34 }}
              </td>
              <td>
                {{ fparReportData.fparTables[6].rows.current[3].age_35To_39 }}
              </td>
              <td>
                {{ fparReportData.fparTables[6].rows.current[3].age_40To_44 }}
              </td>
              <td>
                {{ fparReportData.fparTables[6].rows.current[3].ageOver_44 }}
              </td>
              <td>{{ rowTotals[6][3] }}</td>
            </tr>
            <tr>
              <td>3-Month hormonal injection</td>
              <td>
                {{ fparReportData.fparTables[6].rows.current[4].ageUnder_15 }}
              </td>
              <td>
                {{ fparReportData.fparTables[6].rows.current[4].age_15To_17 }}
              </td>
              <td>
                {{ fparReportData.fparTables[6].rows.current[4].age_18To_19 }}
              </td>
              <td>
                {{ fparReportData.fparTables[6].rows.current[4].age_20To_24 }}
              </td>
              <td>
                {{ fparReportData.fparTables[6].rows.current[4].age_25To_29 }}
              </td>
              <td>
                {{ fparReportData.fparTables[6].rows.current[4].age_30To_34 }}
              </td>
              <td>
                {{ fparReportData.fparTables[6].rows.current[4].age_35To_39 }}
              </td>
              <td>
                {{ fparReportData.fparTables[6].rows.current[4].age_40To_44 }}
              </td>
              <td>
                {{ fparReportData.fparTables[6].rows.current[4].ageOver_44 }}
              </td>
              <td>{{ rowTotals[6][4] }}</td>
            </tr>
            <tr>
              <td>Oral contraceptive</td>
              <td>
                {{ fparReportData.fparTables[6].rows.current[5].ageUnder_15 }}
              </td>
              <td>
                {{ fparReportData.fparTables[6].rows.current[5].age_15To_17 }}
              </td>
              <td>
                {{ fparReportData.fparTables[6].rows.current[5].age_18To_19 }}
              </td>
              <td>
                {{ fparReportData.fparTables[6].rows.current[5].age_20To_24 }}
              </td>
              <td>
                {{ fparReportData.fparTables[6].rows.current[5].age_25To_29 }}
              </td>
              <td>
                {{ fparReportData.fparTables[6].rows.current[5].age_30To_34 }}
              </td>
              <td>
                {{ fparReportData.fparTables[6].rows.current[5].age_35To_39 }}
              </td>
              <td>
                {{ fparReportData.fparTables[6].rows.current[5].age_40To_44 }}
              </td>
              <td>
                {{ fparReportData.fparTables[6].rows.current[5].ageOver_44 }}
              </td>
              <td>{{ rowTotals[6][5] }}</td>
            </tr>
            <tr>
              <td>Contraceptive patch</td>
              <td>
                {{ fparReportData.fparTables[6].rows.current[6].ageUnder_15 }}
              </td>
              <td>
                {{ fparReportData.fparTables[6].rows.current[6].age_15To_17 }}
              </td>
              <td>
                {{ fparReportData.fparTables[6].rows.current[6].age_18To_19 }}
              </td>
              <td>
                {{ fparReportData.fparTables[6].rows.current[6].age_20To_24 }}
              </td>
              <td>
                {{ fparReportData.fparTables[6].rows.current[6].age_25To_29 }}
              </td>
              <td>
                {{ fparReportData.fparTables[6].rows.current[6].age_30To_34 }}
              </td>
              <td>
                {{ fparReportData.fparTables[6].rows.current[6].age_35To_39 }}
              </td>
              <td>
                {{ fparReportData.fparTables[6].rows.current[6].age_40To_44 }}
              </td>
              <td>
                {{ fparReportData.fparTables[6].rows.current[6].ageOver_44 }}
              </td>
              <td>{{ rowTotals[6][6] }}</td>
            </tr>
            <tr>
              <td>Vaginal ring</td>
              <td>
                {{ fparReportData.fparTables[6].rows.current[7].ageUnder_15 }}
              </td>
              <td>
                {{ fparReportData.fparTables[6].rows.current[7].age_15To_17 }}
              </td>
              <td>
                {{ fparReportData.fparTables[6].rows.current[7].age_18To_19 }}
              </td>
              <td>
                {{ fparReportData.fparTables[6].rows.current[7].age_20To_24 }}
              </td>
              <td>
                {{ fparReportData.fparTables[6].rows.current[7].age_25To_29 }}
              </td>
              <td>
                {{ fparReportData.fparTables[6].rows.current[7].age_30To_34 }}
              </td>
              <td>
                {{ fparReportData.fparTables[6].rows.current[7].age_35To_39 }}
              </td>
              <td>
                {{ fparReportData.fparTables[6].rows.current[7].age_40To_44 }}
              </td>
              <td>
                {{ fparReportData.fparTables[6].rows.current[7].ageOver_44 }}
              </td>
              <td>{{ rowTotals[6][7] }}</td>
            </tr>
            <tr>
              <td>Cervical cap/ diaphragm</td>
              <td>
                {{ fparReportData.fparTables[6].rows.current[8].ageUnder_15 }}
              </td>
              <td>
                {{ fparReportData.fparTables[6].rows.current[8].age_15To_17 }}
              </td>
              <td>
                {{ fparReportData.fparTables[6].rows.current[8].age_18To_19 }}
              </td>
              <td>
                {{ fparReportData.fparTables[6].rows.current[8].age_20To_24 }}
              </td>
              <td>
                {{ fparReportData.fparTables[6].rows.current[8].age_25To_29 }}
              </td>
              <td>
                {{ fparReportData.fparTables[6].rows.current[8].age_30To_34 }}
              </td>
              <td>
                {{ fparReportData.fparTables[6].rows.current[8].age_35To_39 }}
              </td>
              <td>
                {{ fparReportData.fparTables[6].rows.current[8].age_40To_44 }}
              </td>
              <td>
                {{ fparReportData.fparTables[6].rows.current[8].ageOver_44 }}
              </td>
              <td>{{ rowTotals[6][8] }}</td>
            </tr>
            <tr>
              <td>Contraceptive sponge</td>
              <td>
                {{ fparReportData.fparTables[6].rows.current[9].ageUnder_15 }}
              </td>
              <td>
                {{ fparReportData.fparTables[6].rows.current[9].age_15To_17 }}
              </td>
              <td>
                {{ fparReportData.fparTables[6].rows.current[9].age_18To_19 }}
              </td>
              <td>
                {{ fparReportData.fparTables[6].rows.current[9].age_20To_24 }}
              </td>
              <td>
                {{ fparReportData.fparTables[6].rows.current[9].age_25To_29 }}
              </td>
              <td>
                {{ fparReportData.fparTables[6].rows.current[9].age_30To_34 }}
              </td>
              <td>
                {{ fparReportData.fparTables[6].rows.current[9].age_35To_39 }}
              </td>
              <td>
                {{ fparReportData.fparTables[6].rows.current[9].age_40To_44 }}
              </td>
              <td>
                {{ fparReportData.fparTables[6].rows.current[9].ageOver_44 }}
              </td>
              <td>{{ rowTotals[6][9] }}</td>
            </tr>
            <tr>
              <td>Female condom</td>
              <td>
                {{ fparReportData.fparTables[6].rows.current[10].ageUnder_15 }}
              </td>
              <td>
                {{ fparReportData.fparTables[6].rows.current[10].age_15To_17 }}
              </td>
              <td>
                {{ fparReportData.fparTables[6].rows.current[10].age_18To_19 }}
              </td>
              <td>
                {{ fparReportData.fparTables[6].rows.current[10].age_20To_24 }}
              </td>
              <td>
                {{ fparReportData.fparTables[6].rows.current[10].age_25To_29 }}
              </td>
              <td>
                {{ fparReportData.fparTables[6].rows.current[10].age_30To_34 }}
              </td>
              <td>
                {{ fparReportData.fparTables[6].rows.current[10].age_35To_39 }}
              </td>
              <td>
                {{ fparReportData.fparTables[6].rows.current[10].age_40To_44 }}
              </td>
              <td>
                {{ fparReportData.fparTables[6].rows.current[10].ageOver_44 }}
              </td>
              <td>{{ rowTotals[6][10] }}</td>
            </tr>
            <tr>
              <td>Any spermicide or non-spermicidal gel (used alone)</td>
              <td>
                {{ fparReportData.fparTables[6].rows.current[11].ageUnder_15 }}
              </td>
              <td>
                {{ fparReportData.fparTables[6].rows.current[11].age_15To_17 }}
              </td>
              <td>
                {{ fparReportData.fparTables[6].rows.current[11].age_18To_19 }}
              </td>
              <td>
                {{ fparReportData.fparTables[6].rows.current[11].age_20To_24 }}
              </td>
              <td>
                {{ fparReportData.fparTables[6].rows.current[11].age_25To_29 }}
              </td>
              <td>
                {{ fparReportData.fparTables[6].rows.current[11].age_30To_34 }}
              </td>
              <td>
                {{ fparReportData.fparTables[6].rows.current[11].age_35To_39 }}
              </td>
              <td>
                {{ fparReportData.fparTables[6].rows.current[11].age_40To_44 }}
              </td>
              <td>
                {{ fparReportData.fparTables[6].rows.current[11].ageOver_44 }}
              </td>
              <td>{{ rowTotals[6][11] }}</td>
            </tr>
            <tr>
              <td>FAM or LAM</td>
              <td>
                {{ fparReportData.fparTables[6].rows.current[12].ageUnder_15 }}
              </td>
              <td>
                {{ fparReportData.fparTables[6].rows.current[12].age_15To_17 }}
              </td>
              <td>
                {{ fparReportData.fparTables[6].rows.current[12].age_18To_19 }}
              </td>
              <td>
                {{ fparReportData.fparTables[6].rows.current[12].age_20To_24 }}
              </td>
              <td>
                {{ fparReportData.fparTables[6].rows.current[12].age_25To_29 }}
              </td>
              <td>
                {{ fparReportData.fparTables[6].rows.current[12].age_30To_34 }}
              </td>
              <td>
                {{ fparReportData.fparTables[6].rows.current[12].age_35To_39 }}
              </td>
              <td>
                {{ fparReportData.fparTables[6].rows.current[12].age_40To_44 }}
              </td>
              <td>
                {{ fparReportData.fparTables[6].rows.current[12].ageOver_44 }}
              </td>
              <td>{{ rowTotals[6][12] }}</td>
            </tr>
            <tr>
              <td>Abstinence</td>
              <td>
                {{ fparReportData.fparTables[6].rows.current[13].ageUnder_15 }}
              </td>
              <td>
                {{ fparReportData.fparTables[6].rows.current[13].age_15To_17 }}
              </td>
              <td>
                {{ fparReportData.fparTables[6].rows.current[13].age_18To_19 }}
              </td>
              <td>
                {{ fparReportData.fparTables[6].rows.current[13].age_20To_24 }}
              </td>
              <td>
                {{ fparReportData.fparTables[6].rows.current[13].age_25To_29 }}
              </td>
              <td>
                {{ fparReportData.fparTables[6].rows.current[13].age_30To_34 }}
              </td>
              <td>
                {{ fparReportData.fparTables[6].rows.current[13].age_35To_39 }}
              </td>
              <td>
                {{ fparReportData.fparTables[6].rows.current[13].age_40To_44 }}
              </td>
              <td>
                {{ fparReportData.fparTables[6].rows.current[13].ageOver_44 }}
              </td>
              <td>{{ rowTotals[6][13] }}</td>
            </tr>
            <tr>
              <td>Withdrawal or other</td>
              <td>
                {{ fparReportData.fparTables[6].rows.current[14].ageUnder_15 }}
              </td>
              <td>
                {{ fparReportData.fparTables[6].rows.current[14].age_15To_17 }}
              </td>
              <td>
                {{ fparReportData.fparTables[6].rows.current[14].age_18To_19 }}
              </td>
              <td>
                {{ fparReportData.fparTables[6].rows.current[14].age_20To_24 }}
              </td>
              <td>
                {{ fparReportData.fparTables[6].rows.current[14].age_25To_29 }}
              </td>
              <td>
                {{ fparReportData.fparTables[6].rows.current[14].age_30To_34 }}
              </td>
              <td>
                {{ fparReportData.fparTables[6].rows.current[14].age_35To_39 }}
              </td>
              <td>
                {{ fparReportData.fparTables[6].rows.current[14].age_40To_44 }}
              </td>
              <td>
                {{ fparReportData.fparTables[6].rows.current[14].ageOver_44 }}
              </td>
              <td>{{ rowTotals[6][14] }}</td>
            </tr>
            <tr>
              <th rowspan="3" scope="row" class="bold">Rely on Male Method</th>
            </tr>
            <tr>
              <td>Vasectomy</td>
              <td>
                {{ fparReportData.fparTables[6].rows.current[15].ageUnder_15 }}
              </td>
              <td>
                {{ fparReportData.fparTables[6].rows.current[15].age_15To_17 }}
              </td>
              <td>
                {{ fparReportData.fparTables[6].rows.current[15].age_18To_19 }}
              </td>
              <td>
                {{ fparReportData.fparTables[6].rows.current[15].age_20To_24 }}
              </td>
              <td>
                {{ fparReportData.fparTables[6].rows.current[15].age_25To_29 }}
              </td>
              <td>
                {{ fparReportData.fparTables[6].rows.current[15].age_30To_34 }}
              </td>
              <td>
                {{ fparReportData.fparTables[6].rows.current[15].age_35To_39 }}
              </td>
              <td>
                {{ fparReportData.fparTables[6].rows.current[15].age_40To_44 }}
              </td>
              <td>
                {{ fparReportData.fparTables[6].rows.current[15].ageOver_44 }}
              </td>
              <td>{{ rowTotals[6][15] }}</td>
            </tr>
            <tr>
              <td>Male condom</td>
              <td>
                {{ fparReportData.fparTables[6].rows.current[16].ageUnder_15 }}
              </td>
              <td>
                {{ fparReportData.fparTables[6].rows.current[16].age_15To_17 }}
              </td>
              <td>
                {{ fparReportData.fparTables[6].rows.current[16].age_18To_19 }}
              </td>
              <td>
                {{ fparReportData.fparTables[6].rows.current[16].age_20To_24 }}
              </td>
              <td>
                {{ fparReportData.fparTables[6].rows.current[16].age_25To_29 }}
              </td>
              <td>
                {{ fparReportData.fparTables[6].rows.current[16].age_30To_34 }}
              </td>
              <td>
                {{ fparReportData.fparTables[6].rows.current[16].age_35To_39 }}
              </td>
              <td>
                {{ fparReportData.fparTables[6].rows.current[16].age_40To_44 }}
              </td>
              <td>
                {{ fparReportData.fparTables[6].rows.current[16].ageOver_44 }}
              </td>
              <td>{{ rowTotals[6][16] }}</td>
            </tr>
            <tr>
              <th rowspan="3" scope="row" class="bold">No Method</th>
            </tr>
            <tr>
              <td>Pregnant/seeking pregnancy</td>
              <td>
                {{ fparReportData.fparTables[6].rows.current[17].ageUnder_15 }}
              </td>
              <td>
                {{ fparReportData.fparTables[6].rows.current[17].age_15To_17 }}
              </td>
              <td>
                {{ fparReportData.fparTables[6].rows.current[17].age_18To_19 }}
              </td>
              <td>
                {{ fparReportData.fparTables[6].rows.current[17].age_20To_24 }}
              </td>
              <td>
                {{ fparReportData.fparTables[6].rows.current[17].age_25To_29 }}
              </td>
              <td>
                {{ fparReportData.fparTables[6].rows.current[17].age_30To_34 }}
              </td>
              <td>
                {{ fparReportData.fparTables[6].rows.current[17].age_35To_39 }}
              </td>
              <td>
                {{ fparReportData.fparTables[6].rows.current[17].age_40To_44 }}
              </td>
              <td>
                {{ fparReportData.fparTables[6].rows.current[17].ageOver_44 }}
              </td>
              <td>{{ rowTotals[6][17] }}</td>
            </tr>
            <tr>
              <td>Other reason</td>
              <td>
                {{ fparReportData.fparTables[6].rows.current[18].ageUnder_15 }}
              </td>
              <td>
                {{ fparReportData.fparTables[6].rows.current[18].age_15To_17 }}
              </td>
              <td>
                {{ fparReportData.fparTables[6].rows.current[18].age_18To_19 }}
              </td>
              <td>
                {{ fparReportData.fparTables[6].rows.current[18].age_20To_24 }}
              </td>
              <td>
                {{ fparReportData.fparTables[6].rows.current[18].age_25To_29 }}
              </td>
              <td>
                {{ fparReportData.fparTables[6].rows.current[18].age_30To_34 }}
              </td>
              <td>
                {{ fparReportData.fparTables[6].rows.current[18].age_35To_39 }}
              </td>
              <td>
                {{ fparReportData.fparTables[6].rows.current[18].age_40To_44 }}
              </td>
              <td>
                {{ fparReportData.fparTables[6].rows.current[18].ageOver_44 }}
              </td>
              <td>{{ rowTotals[6][18] }}</td>
            </tr>
            <tr>
              <th colspan="2" scope="row" class="bold">Unknown/Not Reported</th>
              <td>
                {{ fparReportData.fparTables[6].rows.current[19].ageUnder_15 }}
              </td>
              <td>
                {{ fparReportData.fparTables[6].rows.current[19].age_15To_17 }}
              </td>
              <td>
                {{ fparReportData.fparTables[6].rows.current[19].age_18To_19 }}
              </td>
              <td>
                {{ fparReportData.fparTables[6].rows.current[19].age_20To_24 }}
              </td>
              <td>
                {{ fparReportData.fparTables[6].rows.current[19].age_25To_29 }}
              </td>
              <td>
                {{ fparReportData.fparTables[6].rows.current[19].age_30To_34 }}
              </td>
              <td>
                {{ fparReportData.fparTables[6].rows.current[19].age_35To_39 }}
              </td>
              <td>
                {{ fparReportData.fparTables[6].rows.current[19].age_40To_44 }}
              </td>
              <td>
                {{ fparReportData.fparTables[6].rows.current[19].ageOver_44 }}
              </td>
              <td>{{ rowTotals[6][19] }}</td>
            </tr>
            <tr>
              <th>Total</th>
              <td></td>
              <td class="bold text-align-right">
                {{ columnTotals[11] }}
              </td>
              <td class="bold text-align-right">
                {{ columnTotals[12] }}
              </td>
              <td class="bold text-align-right">
                {{ columnTotals[13] }}
              </td>
              <td class="bold text-align-right">
                {{ columnTotals[14] }}
              </td>
              <td class="bold text-align-right">
                {{ columnTotals[15] }}
              </td>
              <td class="bold text-align-right">
                {{ columnTotals[16] }}
              </td>
              <td class="bold text-align-right">
                {{ columnTotals[17] }}
              </td>
              <td class="bold text-align-right">
                {{ columnTotals[18] }}
              </td>
              <td class="bold text-align-right">
                {{ columnTotals[19] }}
              </td>
              <td class="bold text-align-right">
                {{ totalTotals[6] }}
              </td>
            </tr>
          </tbody>
        </table>
        <app-print-submission-footer
          class="print-footer"
          [year]="dataReportingPeriodYear"
          [granteeName]="fparReportData.granteeName"
          pageNumber="7"
        ></app-print-submission-footer>
      </div>
      <div class="page-break"></div>
      <div class="print-layout">
        <ol class="print-numbered-heading-1">
          <li class="print-numbered-heading-1-item">
            {{ fparReportData.fparTables[7].tableName }}
          </li>
          <li class="print-numbered-heading-1-item-title">
            Unduplicated Number of Male Family Planning Users by Primary Method
            and Age Group
          </li>
        </ol>
        <table class="print-table">
          <colgroup>
            <col class="col-width-68" />
            <col class="col-width-54" />
            <col />
            <col />
            <col />
            <col />
            <col />
            <col />
            <col />
            <col />
            <col />
            <col />
          </colgroup>
          <thead>
            <tr>
              <th></th>
              <th></th>
              <th scope="col">Under 15</th>
              <th scope="col">15 to 17</th>
              <th scope="col">18 to 19</th>
              <th scope="col">20 to 24</th>
              <th scope="col">25 to 29</th>
              <th scope="col">30 to 34</th>
              <th scope="col">35 to 39</th>
              <th scope="col">40 to 44</th>
              <th scope="col">Over 44</th>
              <th scope="col">Total</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <th rowspan="6" scope="row">Primary Method</th>
            </tr>
            <tr>
              <td>Vasectomy</td>
              <td>
                {{ fparReportData.fparTables[7].rows.current[0].ageUnder_15 }}
              </td>
              <td>
                {{ fparReportData.fparTables[7].rows.current[0].age_15To_17 }}
              </td>
              <td>
                {{ fparReportData.fparTables[7].rows.current[0].age_18To_19 }}
              </td>
              <td>
                {{ fparReportData.fparTables[7].rows.current[0].age_20To_24 }}
              </td>
              <td>
                {{ fparReportData.fparTables[7].rows.current[0].age_25To_29 }}
              </td>
              <td>
                {{ fparReportData.fparTables[7].rows.current[0].age_30To_34 }}
              </td>
              <td>
                {{ fparReportData.fparTables[7].rows.current[0].age_35To_39 }}
              </td>
              <td>
                {{ fparReportData.fparTables[7].rows.current[0].age_40To_44 }}
              </td>
              <td>
                {{ fparReportData.fparTables[7].rows.current[0].ageOver_44 }}
              </td>
              <td>{{ rowTotals[7][0] }}</td>
            </tr>
            <tr>
              <td>Male condom</td>
              <td>
                {{ fparReportData.fparTables[7].rows.current[1].ageUnder_15 }}
              </td>
              <td>
                {{ fparReportData.fparTables[7].rows.current[1].age_15To_17 }}
              </td>
              <td>
                {{ fparReportData.fparTables[7].rows.current[1].age_18To_19 }}
              </td>
              <td>
                {{ fparReportData.fparTables[7].rows.current[1].age_20To_24 }}
              </td>
              <td>
                {{ fparReportData.fparTables[7].rows.current[1].age_25To_29 }}
              </td>
              <td>
                {{ fparReportData.fparTables[7].rows.current[1].age_30To_34 }}
              </td>
              <td>
                {{ fparReportData.fparTables[7].rows.current[1].age_35To_39 }}
              </td>
              <td>
                {{ fparReportData.fparTables[7].rows.current[1].age_40To_44 }}
              </td>
              <td>
                {{ fparReportData.fparTables[7].rows.current[1].ageOver_44 }}
              </td>
              <td>{{ rowTotals[7][1] }}</td>
            </tr>
            <tr>
              <td>FAM</td>
              <td>
                {{ fparReportData.fparTables[7].rows.current[2].ageUnder_15 }}
              </td>
              <td>
                {{ fparReportData.fparTables[7].rows.current[2].age_15To_17 }}
              </td>
              <td>
                {{ fparReportData.fparTables[7].rows.current[2].age_18To_19 }}
              </td>
              <td>
                {{ fparReportData.fparTables[7].rows.current[2].age_20To_24 }}
              </td>
              <td>
                {{ fparReportData.fparTables[7].rows.current[2].age_25To_29 }}
              </td>
              <td>
                {{ fparReportData.fparTables[7].rows.current[2].age_30To_34 }}
              </td>
              <td>
                {{ fparReportData.fparTables[7].rows.current[2].age_35To_39 }}
              </td>
              <td>
                {{ fparReportData.fparTables[7].rows.current[2].age_40To_44 }}
              </td>
              <td>
                {{ fparReportData.fparTables[7].rows.current[2].ageOver_44 }}
              </td>
              <td>{{ rowTotals[7][2] }}</td>
            </tr>
            <tr>
              <td>Abstinence</td>
              <td>
                {{ fparReportData.fparTables[7].rows.current[3].ageUnder_15 }}
              </td>
              <td>
                {{ fparReportData.fparTables[7].rows.current[3].age_15To_17 }}
              </td>
              <td>
                {{ fparReportData.fparTables[7].rows.current[3].age_18To_19 }}
              </td>
              <td>
                {{ fparReportData.fparTables[7].rows.current[3].age_20To_24 }}
              </td>
              <td>
                {{ fparReportData.fparTables[7].rows.current[3].age_25To_29 }}
              </td>
              <td>
                {{ fparReportData.fparTables[7].rows.current[3].age_30To_34 }}
              </td>
              <td>
                {{ fparReportData.fparTables[7].rows.current[3].age_35To_39 }}
              </td>
              <td>
                {{ fparReportData.fparTables[7].rows.current[3].age_40To_44 }}
              </td>
              <td>
                {{ fparReportData.fparTables[7].rows.current[3].ageOver_44 }}
              </td>
              <td>{{ rowTotals[7][3] }}</td>
            </tr>
            <tr>
              <td>Withdrawal or other method</td>
              <td>
                {{ fparReportData.fparTables[7].rows.current[4].ageUnder_15 }}
              </td>
              <td>
                {{ fparReportData.fparTables[7].rows.current[4].age_15To_17 }}
              </td>
              <td>
                {{ fparReportData.fparTables[7].rows.current[4].age_18To_19 }}
              </td>
              <td>
                {{ fparReportData.fparTables[7].rows.current[4].age_20To_24 }}
              </td>
              <td>
                {{ fparReportData.fparTables[7].rows.current[4].age_25To_29 }}
              </td>
              <td>
                {{ fparReportData.fparTables[7].rows.current[4].age_30To_34 }}
              </td>
              <td>
                {{ fparReportData.fparTables[7].rows.current[4].age_35To_39 }}
              </td>
              <td>
                {{ fparReportData.fparTables[7].rows.current[4].age_40To_44 }}
              </td>
              <td>
                {{ fparReportData.fparTables[7].rows.current[4].ageOver_44 }}
              </td>
              <td>{{ rowTotals[7][4] }}</td>
            </tr>
            <tr>
              <th colspan="2" scope="row">Rely on Female Method</th>
              <td>
                {{ fparReportData.fparTables[7].rows.current[5].ageUnder_15 }}
              </td>
              <td>
                {{ fparReportData.fparTables[7].rows.current[5].age_15To_17 }}
              </td>
              <td>
                {{ fparReportData.fparTables[7].rows.current[5].age_18To_19 }}
              </td>
              <td>
                {{ fparReportData.fparTables[7].rows.current[5].age_20To_24 }}
              </td>
              <td>
                {{ fparReportData.fparTables[7].rows.current[5].age_25To_29 }}
              </td>
              <td>
                {{ fparReportData.fparTables[7].rows.current[5].age_30To_34 }}
              </td>
              <td>
                {{ fparReportData.fparTables[7].rows.current[5].age_35To_39 }}
              </td>
              <td>
                {{ fparReportData.fparTables[7].rows.current[5].age_40To_44 }}
              </td>
              <td>
                {{ fparReportData.fparTables[7].rows.current[5].ageOver_44 }}
              </td>
              <td>{{ rowTotals[7][5] }}</td>
            </tr>
            <tr>
              <th rowspan="3" scope="row">No Method</th>
            </tr>
            <tr>
              <td>Pregnant/seeking pregnancy</td>
              <td>
                {{ fparReportData.fparTables[7].rows.current[6].ageUnder_15 }}
              </td>
              <td>
                {{ fparReportData.fparTables[7].rows.current[6].age_15To_17 }}
              </td>
              <td>
                {{ fparReportData.fparTables[7].rows.current[6].age_18To_19 }}
              </td>
              <td>
                {{ fparReportData.fparTables[7].rows.current[6].age_20To_24 }}
              </td>
              <td>
                {{ fparReportData.fparTables[7].rows.current[6].age_25To_29 }}
              </td>
              <td>
                {{ fparReportData.fparTables[7].rows.current[6].age_30To_34 }}
              </td>
              <td>
                {{ fparReportData.fparTables[7].rows.current[6].age_35To_39 }}
              </td>
              <td>
                {{ fparReportData.fparTables[7].rows.current[6].age_40To_44 }}
              </td>
              <td>
                {{ fparReportData.fparTables[7].rows.current[6].ageOver_44 }}
              </td>
              <td>{{ rowTotals[7][6] }}</td>
            </tr>
            <tr>
              <td>Other reason</td>
              <td>
                {{ fparReportData.fparTables[7].rows.current[7].ageUnder_15 }}
              </td>
              <td>
                {{ fparReportData.fparTables[7].rows.current[7].age_15To_17 }}
              </td>
              <td>
                {{ fparReportData.fparTables[7].rows.current[7].age_18To_19 }}
              </td>
              <td>
                {{ fparReportData.fparTables[7].rows.current[7].age_20To_24 }}
              </td>
              <td>
                {{ fparReportData.fparTables[7].rows.current[7].age_25To_29 }}
              </td>
              <td>
                {{ fparReportData.fparTables[7].rows.current[7].age_30To_34 }}
              </td>
              <td>
                {{ fparReportData.fparTables[7].rows.current[7].age_35To_39 }}
              </td>
              <td>
                {{ fparReportData.fparTables[7].rows.current[7].age_40To_44 }}
              </td>
              <td>
                {{ fparReportData.fparTables[7].rows.current[7].ageOver_44 }}
              </td>
              <td>{{ rowTotals[7][7] }}</td>
            </tr>
            <tr>
              <th colspan="2" scope="row">Unknown/Not Reported</th>
              <td>
                {{ fparReportData.fparTables[7].rows.current[8].ageUnder_15 }}
              </td>
              <td>
                {{ fparReportData.fparTables[7].rows.current[8].age_15To_17 }}
              </td>
              <td>
                {{ fparReportData.fparTables[7].rows.current[8].age_18To_19 }}
              </td>
              <td>
                {{ fparReportData.fparTables[7].rows.current[8].age_20To_24 }}
              </td>
              <td>
                {{ fparReportData.fparTables[7].rows.current[8].age_25To_29 }}
              </td>
              <td>
                {{ fparReportData.fparTables[7].rows.current[8].age_30To_34 }}
              </td>
              <td>
                {{ fparReportData.fparTables[7].rows.current[8].age_35To_39 }}
              </td>
              <td>
                {{ fparReportData.fparTables[7].rows.current[8].age_40To_44 }}
              </td>
              <td>
                {{ fparReportData.fparTables[7].rows.current[8].ageOver_44 }}
              </td>
              <td>{{ rowTotals[7][8] }}</td>
            </tr>
            <tr>
              <th>Total</th>
              <td></td>
              <td class="bold text-align-right">
                {{ columnTotals[20] }}
              </td>
              <td class="bold text-align-right">
                {{ columnTotals[21] }}
              </td>
              <td class="bold text-align-right">
                {{ columnTotals[22] }}
              </td>
              <td class="bold text-align-right">
                {{ columnTotals[23] }}
              </td>
              <td class="bold text-align-right">
                {{ columnTotals[24] }}
              </td>
              <td class="bold text-align-right">
                {{ columnTotals[25] }}
              </td>
              <td class="bold text-align-right">
                {{ columnTotals[26] }}
              </td>
              <td class="bold text-align-right">
                {{ columnTotals[27] }}
              </td>
              <td class="bold text-align-right">
                {{ columnTotals[28] }}
              </td>
              <td class="bold text-align-right">
                {{ totalTotals[7] }}
              </td>
            </tr>
          </tbody>
        </table>
        <app-print-submission-footer
          class="print-footer"
          [year]="dataReportingPeriodYear"
          [granteeName]="fparReportData.granteeName"
          pageNumber="8"
        ></app-print-submission-footer>
      </div>
      <div class="page-break"></div>
      <div class="print-layout">
        <ol class="print-numbered-heading-1">
          <li class="print-numbered-heading-1-item">
            {{ fparReportData.fparTables[8].tableName }}
          </li>
          <li class="print-numbered-heading-1-item-title">
            Cervical Cancer Screening Activities
          </li>
        </ol>
        <table class="print-table">
          <thead>
            <tr>
              <th></th>
              <th></th>
              <th scope="col">Total</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <th rowspan="5" scope="row">Screening Activity</th>
            </tr>
            <tr>
              <td>
                Unduplicated number of female users who obtained a Pap test
              </td>
              <td>{{ fparReportData.fparTables[8].rows.current[0].value }}</td>
            </tr>
            <tr>
              <td>Number of Pap tests performed</td>
              <td>{{ fparReportData.fparTables[8].rows.current[1].value }}</td>
            </tr>
            <tr>
              <td>Number of Pap tests with an ASC or higher result</td>
              <td>{{ fparReportData.fparTables[8].rows.current[2].value }}</td>
            </tr>
            <tr>
              <td>Number of Pap tests with an HSIL or higher result</td>
              <td>{{ fparReportData.fparTables[8].rows.current[3].value }}</td>
            </tr>
            <tr>
              <th>Total</th>
              <td></td>
              <td class="bold text-align-right">
                {{ totalTotals[8] }}
              </td>
            </tr>
          </tbody>
        </table>
        <app-print-submission-footer
          class="print-footer"
          [year]="dataReportingPeriodYear"
          [granteeName]="fparReportData.granteeName"
          pageNumber="9"
        ></app-print-submission-footer>
      </div>
      <div class="page-break"></div>
      <div class="print-layout">
        <ol class="print-numbered-heading-1">
          <li class="print-numbered-heading-1-item">Table 10</li>
          <li class="print-numbered-heading-1-item-title">
            Clinical Breast Exams and Referrals
          </li>
        </ol>
        <table class="print-table">
          <thead>
            <tr>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <th rowspan="9" scope="row">
                Data associated with clinical breast exams and referrals is no
                longer collected.
              </th>
            </tr>
          </tbody>
        </table>
        <app-print-submission-footer
          class="print-footer"
          [year]="dataReportingPeriodYear"
          [granteeName]="fparReportData.granteeName"
          pageNumber="10"
        ></app-print-submission-footer>
      </div>
      <div class="page-break"></div>
      <div class="print-layout">
        <ol class="print-numbered-heading-1">
          <li class="print-numbered-heading-1-item">
            {{ fparReportData.fparTables[9].tableName }}
          </li>
          <li class="print-numbered-heading-1-item-title">
            Unduplicated Number of Family Planning Users Tested for Chlamydia by
            Age Group and Sex
          </li>
        </ol>
        <table class="print-table">
          <thead>
            <tr>
              <th></th>
              <th></th>
              <th scope="col">Female Users</th>
              <th scope="col">Male Users</th>
              <th scope="col">Total Users</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <th rowspan="6" scope="row" class="bold">Age Group</th>
            </tr>
            <tr>
              <td>Under 15</td>
              <td>{{ fparReportData.fparTables[9].rows.current[0].female }}</td>
              <td>{{ fparReportData.fparTables[9].rows.current[0].male }}</td>
              <td>
                {{ rowTotals[9][0] }}
              </td>
            </tr>
            <tr>
              <td>15 to 17</td>
              <td>{{ fparReportData.fparTables[9].rows.current[1].female }}</td>
              <td>{{ fparReportData.fparTables[9].rows.current[1].male }}</td>
              <td>
                {{ rowTotals[9][1] }}
              </td>
            </tr>
            <tr>
              <td>18 to 19</td>
              <td>{{ fparReportData.fparTables[9].rows.current[2].female }}</td>
              <td>{{ fparReportData.fparTables[9].rows.current[2].male }}</td>
              <td>
                {{ rowTotals[9][2] }}
              </td>
            </tr>
            <tr>
              <td>20 to 24</td>
              <td>{{ fparReportData.fparTables[9].rows.current[3].female }}</td>
              <td>{{ fparReportData.fparTables[9].rows.current[3].male }}</td>
              <td>
                {{ rowTotals[9][3] }}
              </td>
            </tr>
            <tr>
              <td>25 and over</td>
              <td>{{ fparReportData.fparTables[9].rows.current[4].female }}</td>
              <td>{{ fparReportData.fparTables[9].rows.current[4].male }}</td>
              <td>
                {{ rowTotals[9][4] }}
              </td>
            </tr>
            <tr>
              <th>Total</th>
              <td></td>
              <td class="bold text-align-right">
                {{ columnTotals[30] }}
              </td>
              <td class="bold text-align-right">
                {{ columnTotals[31] }}
              </td>
              <td class="bold text-align-right">
                {{ totalTotals[9] }}
              </td>
            </tr>
          </tbody>
        </table>
        <app-print-submission-footer
          class="print-footer"
          [year]="dataReportingPeriodYear"
          [granteeName]="fparReportData.granteeName"
          pageNumber="11"
        ></app-print-submission-footer>
      </div>
      <div class="page-break"></div>
      <div class="print-layout">
        <ol class="print-numbered-heading-1">
          <li class="print-numbered-heading-1-item">
            {{ fparReportData.fparTables[10].tableName }}
          </li>
          <li class="print-numbered-heading-1-item-title">
            Number of Tests for Gonorrhea, Syphilis, and HIV and Number of
            Positive Confidential HIV Tests
          </li>
        </ol>
        <table class="print-table">
          <thead>
            <tr>
              <th></th>
              <th></th>
              <th scope="col" class="text-align-right">Female Users</th>
              <th scope="col" class="text-align-right">Male Users</th>
              <th scope="col" class="text-align-right">Total</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <th rowspan="6" scope="row" class="bold">Test Type</th>
            </tr>
            <tr>
              <td>Gonorrhea</td>
              <td>
                {{ fparReportData.fparTables[10].rows.current[0].female }}
              </td>
              <td>{{ fparReportData.fparTables[10].rows.current[0].male }}</td>
              <td>{{ rowTotals[10][0] }}</td>
            </tr>
            <tr>
              <td>Syphilis</td>
              <td>
                {{ fparReportData.fparTables[10].rows.current[1].female }}
              </td>
              <td>{{ fparReportData.fparTables[10].rows.current[1].male }}</td>
              <td>{{ rowTotals[10][1] }}</td>
            </tr>
            <tr>
              <td>HIV – All confidential tests</td>
              <td>
                {{ fparReportData.fparTables[10].rows.current[2].female }}
              </td>
              <td>{{ fparReportData.fparTables[10].rows.current[2].male }}</td>
              <td>{{ rowTotals[10][2] }}</td>
            </tr>
            <tr>
              <td>HIV – Positive confidential tests</td>
              <td colspan="2" class="background-color-lightgray"></td>
              <td>{{ rowTotals[10][3] }}</td>
            </tr>
            <tr>
              <td>HIV – Anonymous tests</td>
              <td colspan="2" class="background-color-lightgray"></td>
              <td>{{ rowTotals[10][4] }}</td>
            </tr>
            <tr>
              <th>Total</th>
              <td></td>
              <td class="bold text-align-right">
                {{ columnTotals[32] }}
              </td>
              <td class="bold text-align-right">
                {{ columnTotals[33] }}
              </td>
              <td class="bold text-align-right">
                {{ totalTotals[10] }}
              </td>
            </tr>
          </tbody>
        </table>
        <app-print-submission-footer
          class="print-footer"
          [year]="dataReportingPeriodYear"
          [granteeName]="fparReportData.granteeName"
          pageNumber="12"
        ></app-print-submission-footer>
      </div>
      <div class="page-break"></div>
      <div class="print-layout">
        <ol class="print-numbered-heading-1">
          <li class="print-numbered-heading-1-item">
            {{ fparReportData.fparTables[11].tableName }}
          </li>
          <li class="print-numbered-heading-1-item-title">
            Number of Full-Time Equivalent Clinical Services Providers and
            Family Planning Encounters by Type of Provider
          </li>
        </ol>
        <table class="print-table">
          <thead>
            <tr>
              <th></th>
              <th></th>
              <th></th>
              <th scope="col" class="text-align-right">Number of FTEs</th>
              <th scope="col" class="text-align-right">
                Number of Family Planning Encounters
              </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <th rowspan="6" scope="row" class="bold text-transform-uppercase">
                Provider Type
              </th>
            </tr>
            <tr>
              <th rowspan="4" scope="row">Clinical Services Providers</th>
              <td></td>
              <td></td>
              <td class="text-align-right">
                {{
                  removeDecimal(
                    fparReportData.fparTables[11].rows.current[0].fpe
                  )
                }}
              </td>
            </tr>
            <tr>
              <td>Physicians</td>
              <td class="text-align-right">
                {{ fparReportData.fparTables[11].rows.current[1].fte }}
              </td>
              <td rowspan="3"></td>
            </tr>
            <tr>
              <td>
                Physician assistants/nurse practitioners/ certified nurse
                midwives
              </td>
              <td class="text-align-right">
                {{ fparReportData.fparTables[11].rows.current[2].fte }}
              </td>
            </tr>
            <tr>
              <td>
                Registered nurses with an expanded scope of practice who are
                trained and permitted by state-specific regulations to perform
                all aspects of the user physical assessment
              </td>
              <td class="text-align-right">
                {{ fparReportData.fparTables[11].rows.current[3].fte }}
              </td>
            </tr>
            <tr>
              <th>Other Services Providers</th>
              <td></td>
              <td></td>
              <td class="text-align-right">
                {{ fparReportData.fparTables[11].rows.current[4].fpe }}
              </td>
            </tr>
            <tr>
              <th>Total</th>
              <td colspan="4" class="bold text-align-right">
                {{ columnTotals[36] }}
              </td>
            </tr>
          </tbody>
        </table>
        <app-print-submission-footer
          class="print-footer"
          [year]="dataReportingPeriodYear"
          [granteeName]="fparReportData.granteeName"
          pageNumber="13"
        ></app-print-submission-footer>
      </div>
      <div class="page-break"></div>
      <div class="print-layout">
        <ol class="print-numbered-heading-1">
          <li class="print-numbered-heading-1-item">
            {{ fparReportData.fparTables[12].tableName }}
          </li>
          <li class="print-numbered-heading-1-item-title">Revenue Report</li>
        </ol>
        <table class="print-table">
          <thead>
            <tr>
              <th></th>
              <th></th>
              <th></th>
              <th></th>
              <th></th>
              <th>Amount</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <th
                [attr.rowspan]="32 + otherRevenueRows.length"
                scope="row"
                class="bold text-transform-uppercase"
              >
                Revenue Source
              </th>
            </tr>
            <tr>
              <th colspan="4" scope="row">
                Title X grant (Section 1001: family planning services)
              </th>
              <td class="bold">
                {{
                  fparReportData.fparTables[12].rows.current[0].amount?.toString()
                    | currency: 'USD'
                }}
              </td>
            </tr>
            <tr>
              <th rowspan="21">Payment for Services</th>
            </tr>
            <tr>
              <td colspan="3">Total client collections/self-pay</td>
              <td>
                {{
                  fparReportData.fparTables[12].rows.current[1].amount?.toString()
                    | currency: 'USD'
                }}
              </td>
            </tr>
            <tr>
              <td rowspan="16">Third-party payers</td>
            </tr>
            <tr>
              <td rowspan="3">Medicaid (Title XIX)</td>
            </tr>
            <tr>
              <td>Amount Prepaid</td>
              <td class="text-align-right">
                {{
                  fparReportData.fparTables[12].rows.current[2].prepaid?.toString()
                    | currency: 'USD'
                }}
              </td>
            </tr>
            <tr>
              <td>Amount Not Prepaid</td>
              <td>
                {{
                  fparReportData.fparTables[12].rows.current[2].notPrepaid?.toString()
                    | currency: 'USD'
                }}
              </td>
            </tr>
            <tr>
              <td rowspan="3">Medicare (Title XVIII)</td>
            </tr>
            <tr>
              <td>Amount Prepaid</td>
              <td class="text-align-right">
                {{
                  fparReportData.fparTables[12].rows.current[3].prepaid?.toString()
                    | currency: 'USD'
                }}
              </td>
            </tr>
            <tr>
              <td>Amount Not Prepaid</td>
              <td>
                {{
                  fparReportData.fparTables[12].rows.current[3].notPrepaid?.toString()
                    | currency: 'USD'
                }}
              </td>
            </tr>
            <tr>
              <td rowspan="3">Children’s Health Insurance Program (CHIP)</td>
            </tr>
            <tr>
              <td>Amount Prepaid</td>
              <td class="text-align-right">
                {{
                  fparReportData.fparTables[12].rows.current[4].prepaid?.toString()
                    | currency: 'USD'
                }}
              </td>
            </tr>
            <tr>
              <td>Amount Not Prepaid</td>
              <td>
                {{
                  fparReportData.fparTables[12].rows.current[4].notPrepaid?.toString()
                    | currency: 'USD'
                }}
              </td>
            </tr>
            <tr>
              <td rowspan="3">Other public health insurance</td>
            </tr>
            <tr>
              <td>Amount Prepaid</td>
              <td class="text-align-right">
                {{
                  fparReportData.fparTables[12].rows.current[5].prepaid?.toString()
                    | currency: 'USD'
                }}
              </td>
            </tr>
            <tr>
              <td>Amount Not Prepaid</td>
              <td>
                {{
                  fparReportData.fparTables[12].rows.current[5].notPrepaid?.toString()
                    | currency: 'USD'
                }}
              </td>
            </tr>
            <tr>
              <td rowspan="3">Private health insurance</td>
            </tr>
            <tr>
              <td>Amount Prepaid</td>
              <td class="text-align-right">
                {{
                  fparReportData.fparTables[12].rows.current[6].prepaid?.toString()
                    | currency: 'USD'
                }}
              </td>
            </tr>
            <tr>
              <td>Amount Not Prepaid</td>
              <td>
                {{
                  fparReportData.fparTables[12].rows.current[6].notPrepaid?.toString()
                    | currency: 'USD'
                }}
              </td>
            </tr>
            <tr>
              <td rowspan="3" colspan="2">Total – Third-Party Payers</td>
            </tr>
            <tr>
              <td>Amount Prepaid</td>
              <td class="text-align-right">
                {{
                  thirdPartyRevenueTotals.prepaid?.toString() | currency: 'USD'
                }}
              </td>
            </tr>
            <tr>
              <td>Amount Not Prepaid</td>
              <td>
                {{
                  thirdPartyRevenueTotals.notPrepaid?.toString()
                    | currency: 'USD'
                }}
              </td>
            </tr>
            <tr>
              <th colspan="4">Total - Payment for Services</th>
              <td class="bold">
                {{ totalPaymentForServices | currency: 'USD' }}
              </td>
            </tr>
            <tr>
              <th [attr.rowspan]="7 + otherRevenueRows.length">
                Other Revenue
              </th>
            </tr>
            <tr>
              <td colspan="3">Title V (MCH Block Grant)</td>
              <td>
                {{
                  fparReportData.fparTables[12].rows.current[7].amount?.toString()
                    | currency: 'USD'
                }}
              </td>
            </tr>
            <tr>
              <td colspan="3">Title XX (Social Services Block Grant)</td>
              <td>
                {{
                  fparReportData.fparTables[12].rows.current[8].amount?.toString()
                    | currency: 'USD'
                }}
              </td>
            </tr>
            <tr>
              <td colspan="3">
                Temporary Assistance for Needy Families (TANF)
              </td>
              <td>
                {{
                  fparReportData.fparTables[12].rows.current[9].amount?.toString()
                    | currency: 'USD'
                }}
              </td>
            </tr>
            <tr>
              <td colspan="3">Local government revenue</td>
              <td>
                {{
                  fparReportData.fparTables[12].rows.current[10].amount?.toString()
                    | currency: 'USD'
                }}
              </td>
            </tr>
            <tr>
              <td colspan="3">State government revenue</td>
              <td>
                {{
                  fparReportData.fparTables[12].rows.current[11].amount?.toString()
                    | currency: 'USD'
                }}
              </td>
            </tr>
            <tr>
              <td colspan="3">Bureau of Primary Health Care (BPHC)</td>
              <td>
                {{
                  fparReportData.fparTables[12].rows.current[12].amount?.toString()
                    | currency: 'USD'
                }}
              </td>
            </tr>
            @for (item of otherRevenueRows; track item) {
              <tr>
                <td colspan="3">{{ item.rowLabel }}</td>
                <td>
                  {{ item.amount | currency: 'USD' }}
                </td>
              </tr>
            }
            <tr>
              <th colspan="4">Total - Other Revenue</th>
              <td class="bold">
                {{ otherRevenueTotal | currency: 'USD' }}
              </td>
            </tr>
            <tr>
              <th colspan="5" scope="row" class="text-transform-uppercase">
                Total Revenue
              </th>
              <td class="bold">
                {{ revenueTotal | currency: 'USD' }}
              </td>
            </tr>
          </tbody>
        </table>
        <app-print-submission-footer
          class="print-footer"
          [year]="dataReportingPeriodYear"
          [granteeName]="fparReportData.granteeName"
          pageNumber="14"
        ></app-print-submission-footer>
      </div>
      <div class="page-break"></div>
      <div class="print-layout">
        <img
          src="../../../../assets/oash-logo-bw.svg"
          class="print-logo"
          alt="OASH Office of Population Affairs logo"
        />
        <div class="print-title">
          <p class="print-title-intro">
            {{ dataReportingPeriodYear }} FPAR<br />
            Reporting Period<br />
            Summary for
          </p>
          <p class="print-title-grant">{{ fparReportData.granteeName }}</p>
        </div>
        <div class="print-project-director">
          <p class="print-project-director-label">Title X Project Director</p>
          <p class="print-project-director-name">
            {{ grantCoverSheetContact.grContactFirst }}
            {{ grantCoverSheetContact.grContactLast }}
          </p>
        </div>
        <div class="print-contact-person">
          <p class="print-contact-person-label">Grantee Contact Person</p>
          <p class="print-contact-person-name">
            {{ grantCoverSheetDirector.grProjDirFirst }}
            {{ grantCoverSheetDirector.grProjDirLast }}
          </p>
        </div>
        <app-print-submission-footer
          class="print-footer appendix-footer"
          [year]="dataReportingPeriodYear"
          [granteeName]="fparReportData.granteeName"
          pageNumber="15"
        ></app-print-submission-footer>
      </div>
      @if (includeComments()) {
        <div class="page-break"></div>
        <div class="appendix">
          <ol class="print-numbered-heading-1">
            <li class="print-numbered-heading-1-item">Appendix</li>
          </ol>
          <div class="appendix-comments">
            <div class="print-submission-comments">
              <p class="print-notes-heading">Submission Comments</p>
              @if (fparReportData.submissionComment) {
                <p class="print-submission-comment">
                  {{ fparReportData.submissionComment.comment }} -
                  <em class="appendix-comment-metadata">
                    {{ fparReportData.submissionComment.nameFirst }}
                    {{ fparReportData.submissionComment.nameLast }} -
                    {{ fparReportData.submissionComment.lastUpdated | date }}
                  </em>
                </p>
              }
            </div>
            <div class="print-notes">
              <p class="print-notes-heading">Table Comments</p>
              @for (table of fparReportData.fparTables; track table) {
                <div class="no-page-break-between">
                  @if (table.comments?.length > 0) {
                    <strong>{{ table.tableName }}</strong>
                  }
                  @for (comment of table.comments; track comment) {
                    <p class="print-submission-comment">
                      {{ comment.comment }} -
                      <em class="appendix-comment-metadata">
                        {{ comment.author }} - {{ comment.addedDate | date }}
                        @if (comment.addedDate !== comment.updatedDate) {
                          <span>(edited {{ comment.updatedDate | date }})</span>
                        }
                      </em>
                    </p>
                  }
                </div>
              }
            </div>
            <div class="table-issues-and-comments">
              <p class="print-notes-heading">Table Issues and Comments</p>
              @for (table of fparReportData.fparTables; track table) {
                <!-- Only display tables that have issues or comments -->
                @if (table.issues?.length > 0) {
                  <div class="table-section">
                    <h3>
                      Table {{ table.tableNumber }}:
                      {{ table.tableTitle }}
                    </h3>

                    <!-- Issue Groups (Within Table, Cross Table, etc.) -->
                    @for (issueGroup of table.issues; track issueGroup) {
                      <div class="issue-group">
                        <h4>
                          {{ issueGroup.label }}
                          <span class="issue-count"
                            >({{ issueGroup.issueCount }})</span
                          >
                        </h4>

                        <!-- Individual Issues -->
                        @for (issue of issueGroup.list; track issue) {
                          <div class="issue-item">
                            <div class="issue-header">
                              <strong>{{ issue.checkId }}</strong>
                              @if (issue.newIssue) {
                                <span class="badge-new">New</span>
                              }
                              @if (issue.onHold) {
                                <span class="badge-hold">On Hold</span>
                              }
                            </div>

                            <div class="issue-message">
                              {{ issue.displayMessage }}
                            </div>

                            <!-- Issue Comments -->
                            @if (table.issueComments?.length > 0) {
                              <div class="issue-comments">
                                @for (
                                  comment of table.issueComments;
                                  track comment
                                ) {
                                  @if (comment.checkId === issue.checkId) {
                                    <div class="comment no-page-break-inside">
                                      <div class="comment-meta">
                                        <strong>{{ comment.author }}</strong>
                                        <span class="role"
                                          >({{ comment.role }})</span
                                        >
                                        <span class="date">
                                          {{
                                            comment.addedDate | date: 'short'
                                          }}
                                        </span>
                                      </div>

                                      <div class="comment-body">
                                        {{ comment.comment }}
                                      </div>

                                      <!-- Replies -->
                                      @if (comment.replies?.length > 0) {
                                        <div
                                          class="replies no-page-break-inside"
                                        >
                                          @for (
                                            reply of comment.replies;
                                            track reply
                                          ) {
                                            <div
                                              class="reply no-page-break-inside"
                                            >
                                              <div class="comment-meta">
                                                <strong>{{
                                                  reply.author
                                                }}</strong>
                                                <span class="role"
                                                  >({{ reply.role }})</span
                                                >
                                                <span class="date">
                                                  {{
                                                    reply.addedDate
                                                      | date: 'short'
                                                  }}
                                                </span>
                                              </div>
                                              <div class="comment-body">
                                                {{ reply.comment }}
                                              </div>
                                            </div>
                                          }
                                        </div>
                                      }
                                    </div>
                                  }
                                }
                              </div>
                            }
                          </div>
                        }
                      </div>
                    }
                  </div>
                  <hr />
                }
              }
            </div>
          </div>
        </div>
      }
    </div>
  </div>
}
